
<template>
  <v-simple-table class="estimate-group-table">
    <tbody>
      <TitleRow>
        {{ group.title }}
        <span>{{ group.description }}</span>
      </TitleRow>

      <tr v-for="(item, i) in group.items" :key="'group-item-' + i" :title="item.description">
        <td class="py-2">
          <div v-if="item.label && item.label !== item.title">
            <strong class="secondary--text">{{ item.label }}</strong>
          </div>

          <div v-html="item.title" />
          <div class="secondary-text" v-if="showDescription">
            <small v-html="item.description"></small>
          </div>
        </td>
        <td class="text-no-wrap text-right">
          <div v-html="price(item.price)"></div>
        </td>
      </tr>
    </tbody>
  </v-simple-table>
</template>

<script>
import TitleRow from "./TitleRow";

export default {
  components: {
    TitleRow,
  },

  props: {
    group: {
      type: Object,
      required: true,
    },
    showDescription: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    price(price) {
      return Number.isInteger(price) ? price + " €" : price;
    },
  },
};
</script>
